// File: src/pages/EditProductPage.js

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { FaArrowLeft, FaSyncAlt } from 'react-icons/fa';

import './AddProductPage.css'; // Reusing CSS
import SideNav from '../components/SideNav';
import useLicenseCheck from "../hooks/useLicenseCheck";
const EditProductPage = () => {
useLicenseCheck();//

  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    category: '',
    quantity: '',
    sku: '',
    expiry_date: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://installmentzone.com/pharmacy/api';

  // ===================================================================
  // THIS IS THE CORRECTED DATA FETCHING LOGIC
  // ===================================================================
  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        // 1. Fetch the ENTIRE list of products
        const token = localStorage.getItem("token");

const response = await axios.get(`${API_BASE_URL}/get_products.php`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        
        if (response.data.status === 'success' && Array.isArray(response.data.data)) {
          // 2. Find the ONE product from the list that matches the ID from the URL
          // We use `==` for loose comparison because `id` from URL is a string
          const productToEdit = response.data.data.find(product => product.id == id);

          if (productToEdit) {
            // 3. If the product is found, format the date and set the form data
            if (productToEdit.expiry_date) {
              productToEdit.expiry_date = productToEdit.expiry_date.split(' ')[0];
            }
            setFormData(productToEdit); // This now correctly sets an OBJECT, not an array
          } else {
            // 4. If no product with that ID is found in the list
            setError(`Product with ID ${id} not found.`);
          }
        } else {
          setError('Could not retrieve product list from the server.');
        }
      } catch (err) {
        console.error('Error fetching product details:', err);
        setError('Failed to load product data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductDetails();
  }, [id, API_BASE_URL]);


  // --- The rest of your component's logic is correct and does not need changes ---

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.price) {
      setError('Product Name and Price are required.');
      return;
    }
    setIsSubmitting(true);
    setError('');

    try {
      const token = localStorage.getItem("token");

const response = await axios.post(
  `${API_BASE_URL}/update_product.php`,
  { ...formData, id },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      if (response.data.status === 'success') {
        alert('Product updated successfully!');
        navigate('/products');
      } else {
        setError(response.data.message || 'Failed to update product.');
      }
    } catch (err) {
      console.error('Error updating product:', err);
      setError('An error occurred while updating the product.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="add-product-page-container">
        <SideNav activePage="Products" />
        <main className="add-product-main-content">
          <p>Loading product details...</p>
        </main>
      </div>
    );
  }

  // --- Your JSX is also correct and does not need changes ---
  return (
    <div className="add-product-page-container">
      <SideNav activePage="Products" />
      <main className="add-product-main-content">
        <header className="page-header">
          <h1>Edit Product</h1>
          <div className="header-actions">
            <button onClick={() => navigate('/products')} className="back-btn">
              <FaArrowLeft />
              Back to List
            </button>
          </div>
        </header>

        <div className="content-card">
          {error ? (
             <p className="form-error-message">{error}</p>
          ) : (
            <form onSubmit={handleSubmit} className="add-product-form">
              {/* All form inputs will now be correctly pre-filled */}
              <div className="form-group">
                <label htmlFor="name" className="form-label">Product Name</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="sku" className="form-label">SKU</label>
                <input type="text" id="sku" name="sku" value={formData.sku} onChange={handleChange} className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="category" className="form-label">Category</label>
                <input type="text" id="category" name="category" value={formData.category} onChange={handleChange} className="form-input" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="price" className="form-label">Price</label>
                  <input type="number" id="price" name="price" step="0.01" value={formData.price} onChange={handleChange} className="form-input" required />
                </div>
                <div className="form-group">
                  <label htmlFor="quantity" className="form-label">Quantity</label>
                  <input type="number" id="quantity" name="quantity" value={formData.quantity} onChange={handleChange} className="form-input" required />
                </div>
                <div className="form-group">
                  <label htmlFor="expiry_date" className="form-label">Expiry Date</label>
                  <input type="date" id="expiry_date" name="expiry_date" value={formData.expiry_date || ''} onChange={handleChange} className="form-input" />
                </div>
              </div>

              {error && <p className="form-error-message">{error}</p>}

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                <FaSyncAlt />
                {isSubmitting ? 'Updating...' : 'Update Product'}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
};

export default EditProductPage;